import React from 'react';

const ErrorRoutes = props => {
  return <div>Error Routes</div>;
};

export default ErrorRoutes;
